const DEV = process.env.NODE_ENV === 'development'

export default {
  init() {
    const editorialElement = document.getElementById('editorialAnimation')
    const editorialVideoElement = document.getElementById(
      'editorialVideoAnimation'
    )
    const editorialAnimationFiumeElement = document.getElementById(
      'editorialFiumeAnimation'
    )
    const editorialAnimationStatuaElement = document.getElementById(
      'editorialStatuaAnimation'
    )

    if (editorialElement) {
      import('../modules/coccodrillo.js')
        .then((module) => {
          module.initCoccodrilloAnimation()
        })
        .catch((error) => {
          console.error('Errore nel caricamento di editorialAnimation:', error)
        })
    }

    if (editorialVideoElement) {
      import('../modules/videoHeader.js')
        .then((module) => {
          module.initVideoAnimation()
        })
        .catch((error) => {
          console.error(
            'Errore nel caricamento di editorialVideoAnimation:',
            error
          )
        })
    }
    if (editorialAnimationFiumeElement) {
      import('../modules/fiume.js')
        .then((module) => {
          module.initFiumeAnimation()
        })
        .catch((error) => {
          console.error(
            'Errore nel caricamento di editorialAnimationFiumeElement:',
            error
          )
        })
    }
    if (editorialAnimationStatuaElement) {
      import('../modules/statua.js')
        .then((module) => {
          module.initStatuaAnimation()
        })
        .catch((error) => {
          console.error(
            'Errore nel caricamento di editorialAnimationStatuaElement:',
            error
          )
        })
    }
  },

  finalize() {
    // cleanup se serve
  },
}
